"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@unidriver/core");
var test_utils_1 = require("react-dom/test-utils");
var core_2 = require("@unidriver/core");
var core_3 = require("@unidriver/core");
var isPromise = function (a) {
    return !!(a.then);
};
exports.jsdomReactUniDriverList = function (containerOrFn) {
    var elem = function () { return __awaiter(_this, void 0, void 0, function () {
        var elements, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    elements = typeof containerOrFn === 'function' ? containerOrFn() : containerOrFn;
                    if (!isPromise(elements)) return [3 /*break*/, 2];
                    return [4 /*yield*/, elements];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = elements;
                    _b.label = 3;
                case 3: return [2 /*return*/, _a];
            }
        });
    }); };
    return {
        get: function (idx) { return exports.jsdomReactUniDriver(function () {
            return elem().then(function (cont) {
                var elem = cont[idx];
                if (!elem) {
                    throw new Error('React base driver - element was not found');
                }
                else {
                    return elem;
                }
            });
        }); },
        text: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, elem()];
                case 1: return [2 /*return*/, (_a.sent()).map(function (e) { return e.textContent || ''; })];
            }
        }); }); },
        count: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, elem()];
                case 1: return [2 /*return*/, (_a.sent()).length];
            }
        }); }); },
        map: function (fn) { return __awaiter(_this, void 0, void 0, function () {
            var children, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = (_a = Array).from;
                        return [4 /*yield*/, elem()];
                    case 1:
                        children = _b.apply(_a, [_c.sent()]);
                        return [2 /*return*/, Promise.all(children.map(function (e, idx) {
                                return fn(exports.jsdomReactUniDriver(e), idx);
                            }))];
                }
            });
        }); },
        filter: function (fn) {
            return exports.jsdomReactUniDriverList(function () { return __awaiter(_this, void 0, void 0, function () {
                var elems, results;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, elem()];
                        case 1:
                            elems = _a.sent();
                            return [4 /*yield*/, Promise.all(elems.map(function (e, i) {
                                    var bd = exports.jsdomReactUniDriver(e);
                                    return fn(bd, i);
                                }))];
                        case 2:
                            results = _a.sent();
                            return [2 /*return*/, elems.filter(function (_, i) {
                                    return results[i];
                                })];
                    }
                });
            }); });
        }
    };
};
var elementIsFocusable = function (el) {
    return (el.tagName === 'INPUT' ||
        el.tagName === 'SELECT' ||
        el.tagName === 'TEXTAREA' ||
        el.tagName === 'BUTTON');
};
var isCheckable = function (el) {
    return (el.tagName === 'INPUT' &&
        (el.type == 'checkbox' ||
            el.type == 'radio'));
};
exports.jsdomReactUniDriver = function (containerOrFn) {
    var elem = function () { return __awaiter(_this, void 0, void 0, function () {
        var container;
        return __generator(this, function (_a) {
            container = typeof containerOrFn === 'function' ? containerOrFn() : containerOrFn;
            if (!container) {
                throw new Error('React base driver - element was not found');
            }
            return [2 /*return*/, container];
        });
    }); };
    var exists = function () { return __awaiter(_this, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, elem()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    e_1 = _a.sent();
                    if (core_3.isMultipleElementsWithLocatorError(e_1)) {
                        throw e_1;
                    }
                    else {
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleCheckableInput = function (input) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            input.checked = !input.checked;
            test_utils_1.Simulate.input(input);
            test_utils_1.Simulate.change(input);
            return [2 /*return*/];
        });
    }); };
    return {
        $: function (loc) {
            var getElement = function () { return __awaiter(_this, void 0, void 0, function () {
                var container, elements;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, elem()];
                        case 1:
                            container = _a.sent();
                            elements = container.querySelectorAll(loc);
                            if (!elements.length) {
                                throw new core_2.NoElementWithLocatorError(loc);
                            }
                            else if (elements.length > 1) {
                                throw new core_3.MultipleElementsWithLocatorError(elements.length, loc);
                            }
                            return [2 /*return*/, elements[0]];
                    }
                });
            }); };
            return exports.jsdomReactUniDriver(getElement);
        },
        $$: function (selector) { return exports.jsdomReactUniDriverList(function () { return __awaiter(_this, void 0, void 0, function () {
            var e;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, elem()];
                    case 1:
                        e = _a.sent();
                        return [2 /*return*/, Array.from(e.querySelectorAll(selector))];
                }
            });
        }); }); },
        text: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, elem().then(function (e) { return e.textContent || ''; })];
        }); }); },
        value: function () { return __awaiter(_this, void 0, void 0, function () {
            var e;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, elem()];
                    case 1:
                        e = (_a.sent());
                        return [2 /*return*/, e.value];
                }
            });
        }); },
        click: function () { return __awaiter(_this, void 0, void 0, function () {
            var el, eventData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, elem()];
                    case 1:
                        el = _a.sent();
                        eventData = { button: 0 };
                        // setting button 0 is now needed in React 16+ as it's not set by react anymore
                        // 15 - https://github.com/facebook/react/blob/v15.6.1/src/renderers/dom/client/syntheticEvents/SyntheticMouseEvent.js#L45
                        // 16 - https://github.com/facebook/react/blob/master/packages/react-dom/src/events/SyntheticMouseEvent.js#L33
                        test_utils_1.Simulate.mouseDown(el, eventData);
                        if (elementIsFocusable(el)) {
                            if (document.activeElement != el) {
                                if (document.activeElement) {
                                    test_utils_1.Simulate.blur(document.activeElement);
                                }
                                if (!el.disabled) {
                                    el.focus();
                                    test_utils_1.Simulate.focus(el);
                                }
                            }
                        }
                        test_utils_1.Simulate.mouseUp(el, eventData);
                        test_utils_1.Simulate.click(el, eventData);
                        if (isCheckable(el)) {
                            handleCheckableInput(el);
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        mouse: {
            press: function () { return __awaiter(_this, void 0, void 0, function () {
                var el;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, elem()];
                        case 1:
                            el = _a.sent();
                            test_utils_1.Simulate.mouseDown(el);
                            return [2 /*return*/];
                    }
                });
            }); },
            release: function () { return __awaiter(_this, void 0, void 0, function () {
                var el;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, elem()];
                        case 1:
                            el = _a.sent();
                            test_utils_1.Simulate.mouseUp(el);
                            return [2 /*return*/];
                    }
                });
            }); },
            moveTo: function (to) { return __awaiter(_this, void 0, void 0, function () {
                var el, _a, left, top;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, elem()];
                        case 1:
                            el = _b.sent();
                            return [4 /*yield*/, to.getNative()];
                        case 2:
                            _a = (_b.sent()).getBoundingClientRect(), left = _a.left, top = _a.top;
                            test_utils_1.Simulate.mouseMove(el, { clientX: left, clientY: top });
                            return [2 /*return*/];
                    }
                });
            }); }
        },
        hover: function () { return __awaiter(_this, void 0, void 0, function () {
            var el;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, elem()];
                    case 1:
                        el = _a.sent();
                        test_utils_1.Simulate.mouseOver(el);
                        test_utils_1.Simulate.mouseEnter(el);
                        return [2 /*return*/];
                }
            });
        }); },
        pressKey: function (key) { return __awaiter(_this, void 0, void 0, function () {
            var el, def;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, elem()];
                    case 1:
                        el = _a.sent();
                        def = core_1.getDefinitionForKeyType(key);
                        // enabling this throws an error with JSDOM. Thuss, pesskey will only use Simulate
                        /*
                         if (document.body.contains(el)) {
                        // 	const keydown = new KeyboardEvent('keydown', {...def});
                        // 	const keyup = new KeyboardEvent('keyup', {...def});
            
            
                        // 	keydown.initEvent(keydown.type, true, false);
                        // 	el.dispatchEvent(keydown);
                        // 	await (Promise.resolve());
                        // 	keyup.initEvent(keyup.type, true, false);
                        // 	el.dispatchEvent(keyup)
            
                        // } else {
                            
                        // }
                        */
                        test_utils_1.Simulate.keyDown(el, def);
                        test_utils_1.Simulate.keyUp(el, def);
                        return [2 /*return*/];
                }
            });
        }); },
        hasClass: function (className) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, elem()];
                case 1: return [2 /*return*/, (_a.sent()).classList.contains(className)];
            }
        }); }); },
        enterValue: function (value) { return __awaiter(_this, void 0, void 0, function () {
            var el;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, elem()];
                    case 1:
                        el = (_a.sent());
                        el.value = value;
                        test_utils_1.Simulate.change(el);
                        return [2 /*return*/];
                }
            });
        }); },
        attr: function (name) { return __awaiter(_this, void 0, void 0, function () {
            var el;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, elem()];
                    case 1:
                        el = _a.sent();
                        return [2 /*return*/, el.getAttribute(name)];
                }
            });
        }); },
        exists: exists,
        isDisplayed: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, true];
            });
        }); },
        wait: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, core_1.waitFor(exists)];
            });
        }); },
        type: 'react',
        scrollIntoView: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, {}];
        }); }); },
        getNative: function () { return elem(); },
        _prop: function (name) { return __awaiter(_this, void 0, void 0, function () {
            var el;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, elem()];
                    case 1:
                        el = _a.sent();
                        return [2 /*return*/, el[name]];
                }
            });
        }); }
    };
};
//# sourceMappingURL=index.js.map